import React from "react";
import {Link, useTheme} from "@mui/material";
import Box from "@mui/material/Box";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";


export const HostnamesAsLinks = ({hostnames}: { hostnames: string[] }): React.JSX.Element => {
    const theme = useTheme();
    return (
        <Box sx={{ minWidth: 0 }}>
            {hostnames.map(h => (
                <Box key={h} display="flex" alignItems="flex-start" sx={{ minWidth: 0 }}>
                    <Link
                        href={`https://${h}`}
                        target="_blank"
                        rel="noopener"
                        sx={{ overflowWrap: "anywhere", minWidth: 0 }}
                    >
                        {h}
                    </Link>
                    <Link sx={{ pt: "4px", pl: "4px", flexShrink: 0, ":hover": { color: theme.palette.grey[700] } }} href={`https://${h}`}
                          target="_blank" rel="noopener">
                        <ExitToAppIcon sx={{ fontSize: 14, color: theme.palette.grey[500] }}/>
                    </Link>
                </Box>
            ))}
        </Box>
    )
}
